var React = require('react');

function IconCaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M85.3,46.8c-1.1-1.4-3.2-1.5-4.5-0.4L50,72L19.3,46.4c-1.4-1.1-3.4-0.9-4.5,0.4c-1.1,1.4-1,3.4,0.4,4.5l32.8,27.3 c0.6,0.5,1.3,0.7,2.1,0.7c0.7,0,1.5-0.2,2.1-0.7l32.8-27.3C86.2,50.2,86.4,48.1,85.3,46.8z"}));
}

IconCaretDown.defaultProps = {"version":"1.1","x":"0px","y":"0px","xmlSpace":"preserve","width":"36","height":"18","viewBox":"10 40 80 100","preserveAspectRatio":"xMinYMin slice"};

module.exports = IconCaretDown;

IconCaretDown.default = IconCaretDown;
